import React, { useMemo } from 'react';
import { DataObject } from '../../../../types/redux/data/dataTypes';
import GridItem from '../../../layout/GridComponents/GridItem';
import CustomTable from '../../../tables/CustomTable';
import {
  OverviewTableData,
  createMainTableData,
  nursOverviewCsvFields,
  useOverviewColumns,
} from './data';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import { useSelector } from 'react-redux';
import { clientNameSelector } from '../../../../redux/auth/selectors';
import { activeSectionSelector } from '../../../../redux/pages/selectors';
import { useDemoFundIds } from '../../../../hooks/useDemoFundIds';
import { demoRowStyle } from '../../../../utilities/demoFundUtils';

interface DeceasedTableProps {
  reportsData: DataObject;
  tableData: DataObject;
  pageId?: string;
}

const DeceasedTable: React.FC<DeceasedTableProps> = (props) => {
  const clientName = useSelector(clientNameSelector);
  const section = useSelector(activeSectionSelector);
  const demoFundIds = useDemoFundIds(section || 'nurs', props.pageId);
  const columns: CustomColumn<OverviewTableData>[] =
    useOverviewColumns(clientName);
  const data = useMemo(
    () =>
      createMainTableData(
        props.tableData.data[0].data,
        props.reportsData.data,
        demoFundIds,
      ),
    [props.tableData, props.reportsData, demoFundIds],
  );
  return (
    <GridItem card xs={12}>
      <CustomTable<OverviewTableData>
        csvFields={nursOverviewCsvFields}
        showToolbar
        toolbarComponents={{
          toolbarTitle: 'Deceased Data',
        }}
        columns={columns}
        data={data}
        options={{
          paging: false,
          pageSize: 10,
          pageSizeOptions: [10, 20, data.length],
          search: true,
          exportButton: true,
          rowStyle: demoRowStyle<OverviewTableData>({ padding: '0.62rem' }),
        }}
      />
    </GridItem>
  );
};

export default DeceasedTable;
